import {
  LineToggleGroup,
  LineToggleGroupItem,
} from "@/components/line-picker/line-toggle-group"
import { ProductTabIndicator } from "@/components/product-tabs"
import { cn } from "@/lib/utils"

export type LinePickerProps = {
  className?: string
  options: LinePickerOption[]
  defaultValue?: string
  value?: string
  indicators?: ProductTabIndicator[]
  onChange?: (value: string) => void
}

export type LinePickerOption = {
  label: string
  value: string
}

export default function LinePicker({
  className,
  options,
  value,
  defaultValue,
  indicators,
  onChange,
}: LinePickerProps) {
  function handleChange(value: string) {
    if (onChange && value) {
      onChange(value)
    }
  }

  return (
    <LineToggleGroup
      className={cn("relative z-0 line-picker", className)}
      type="single"
      value={value}
      defaultValue={defaultValue}
      onValueChange={handleChange}
    >
      {options.map((option, index) => (
        <LineToggleGroupItem
          key={option.value}
          className="z-0 relative"
          value={option.value}
          indicator={indicators?.at(index)}
        >
          {option.label}
        </LineToggleGroupItem>
      ))}
    </LineToggleGroup>
  )
}
